import type { AuthAdapter } from "./types.js";

/**
 * The mock journey for development without a provider and for the parity
 * tests: the console renders both sign-in steps itself, exactly as the
 * prototype does, and "I have approved it" produces a token the MSW handlers
 * accept. Never shipped with VITE_AUTH_MODE=oidc.
 */
export const MOCK_TOKEN_KEY = "riea-mock-token";

export type MockStep = "signed_out" | "mfa" | "signed_in";

export function createMockAuth(storage: Storage = window.sessionStorage): AuthAdapter & {
  step(): MockStep;
  approveMfa(): void;
  back(): void;
} {
  const listeners = new Set<() => void>();
  const notify = () => listeners.forEach((l) => l());
  let step: MockStep = storage.getItem(MOCK_TOKEN_KEY) ? "signed_in" : "signed_out";
  return {
    mode: "mock",
    step: () => step,
    getToken() {
      return Promise.resolve(step === "signed_in" ? storage.getItem(MOCK_TOKEN_KEY) : null);
    },
    signIn() {
      step = "mfa";
      notify();
      return Promise.resolve();
    },
    approveMfa() {
      storage.setItem(MOCK_TOKEN_KEY, "mock-token-priya");
      step = "signed_in";
      notify();
    },
    back() {
      step = "signed_out";
      notify();
    },
    completeSignIn() {
      return Promise.resolve();
    },
    signOut() {
      storage.removeItem(MOCK_TOKEN_KEY);
      step = "signed_out";
      notify();
      return Promise.resolve();
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
